<template>
  <div>
    <div class="columns">
      <div class="column is-3">
        <p class="subtitle">Cities</p>
        <a class="button is-primary full-width-button mb-1" @click="openAddCityDialog">
          <span class="icon is-small">
            <i class="fas fa-plus"></i>
          </span>
          <span>Add city</span>
        </a>
        <p v-if="isLoading">Loading cities...</p>
        <div class="city-sidebar" v-if="!isLoading">
          <div v-for="city in cities" :key="city.docId" class="card" :class="{'is-active': isCitySelected(city)}">
            <div class="card-content">
              <div class="city-container">
                <p>{{city.name}}</p>
                <div>
                  <a class="button is-small is-primary" @click="changeCitySelected(city)">
                    <span class="icon is-small">
                      <i class="fas fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <p class="subtitle" v-if="!citySelected">No city selected</p>
        <p v-if="!citySelected">Please select a city.</p>
        <p class="subtitle" v-if="citySelected">{{citySelected.name}}</p>
        <div class="card" v-if="citySelected">
          <div class="card-content">
            <b-tabs type="is-boxed" expanded v-model="activeTab">
              <b-tab-item label="Analytics">
                <analytics :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Information">
                <information :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Delivery options">
                <delivery-options :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Delivery boys">
                <delivery-boys :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Zipcodes">
                <zipcodes :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Products">
                <products :city="citySelected" />
              </b-tab-item>
              
              <b-tab-item label="Banners">
                <banners :city="citySelected" />
              </b-tab-item>

              <b-tab-item label="Offers">
                <offers :city="citySelected" />
              </b-tab-item>

              <!-- <b-tab-item label="Orders">
                <orders :city="citySelected" />
              </b-tab-item> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Analytics from './Analytics/Analytics';
import Information from './Information/Information';
import DeliveryOptions from './DeliveryOptions/DeliveryOptions';
import DeliveryBoys from './DeliveryBoys/DeliveryBoys';
import Zipcodes from './Zipcodes/Zipcodes';
import Products from './Products/Products';
import Orders from './Orders/Orders';
import Banners from './Banners/Banners';
import Offers from './Offers/Offers';

import CityService from './service';

export default {
  name: 'cities',

  components: {
    Analytics,
    Information,
    DeliveryOptions,
    DeliveryBoys,
    Zipcodes,
    Products,
    Orders,
    Banners,
    Offers
  },

  created() {
    this.fetchCities();
  },

  data() {
    return {
      activeTab: 0,
      isLoading: true,
      cities: [],
      citySelected: null
    };
  },

  methods: {
    fetchCities() {
      CityService.all().then(cities => {
        this.cities = cities;
        this.isLoading = false;
      });
    },

    isCitySelected(city) {
      return this.citySelected && this.citySelected.docId === city.docId;
    },

    changeCitySelected(city) {
      this.citySelected = city;
      this.$bus.$emit('CITY_CHANGED', city);
      this.$toast.open('Current city updated');
    },

    openAddCityDialog() {
      this.$dialog.prompt({
        message: `Enter city name`,
        inputAttrs: {
          placeholder: 'e.g. Vadodara'
        },
        onConfirm: value => {
          this.isLoading = true;

          CityService.add(value).then(response => {
            const newCity = {
              docId: response.id,
              name: value
            };

            this.cities.push(newCity);
            this.isLoading = false;
            this.$toast.open(`City added successfully`);
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.city-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.card-content {
  padding: 0.75rem;
}
</style>




// WEBPACK FOOTER //
// src/pages/cities/Cities.vue